import React from 'react'

interface CartBadgeProps {
  count: number
}

export const CartBadge: React.FC<CartBadgeProps> = ({ count }) => {
  const display = count > 99 ? '99+' : String(count ?? 0)

  return (
    <span
      aria-label={`${count} item${count !== 1 ? 's' : ''} in cart`}
      className="
        absolute -top-1.5 -right-1.5
        min-w-[18px] h-[18px] px-1
        bg-royal-orange text-white
        text-[10px] font-bold font-sans leading-none
        rounded-full flex items-center justify-center
        tabular-nums select-none
        ring-2 ring-white
      "
    >
      {display}
    </span>
  )
}